import { AxiosError } from "axios";
import { PaginateResult } from "core/resources/types/shared";
import http from "infra/http";
import { useQuery } from "react-query";
import { AnimalItem, ListarAnimaisQuery } from "../typings";

export function useListarAnimais(query: ListarAnimaisQuery) {
  return useQuery<PaginateResult<AnimalItem>, AxiosError>(
    `/v1/animal-${query.search}-${query.page}-${query.limit}-${query.unidadeId}`,
    async () => {
      const { data } = await http.get<PaginateResult<AnimalItem>>("/v1/animal", {
        params: query,
      });

      return data;
    }
  );
}
